import { render } from "./NavDestinations.vue?vue&type=template&id=0c44bac1&ts=true"
import script from "./NavDestinations.vue?vue&type=script&lang=ts"
export * from "./NavDestinations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__